import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.board.all');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-board-all',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.board.all/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminBoardAllComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public categoryMap: any = {
        notice: '공지사항',
        community: '커뮤니티',
        qna: '문의사항',
        expert: '전문가풀',
        period_change: '시기변경신청',
        general: '일반',
        media: '미디어',
        news: '기업현황',
        report: '운용보고',
        company_log: '활동기록',
        company_comment: '관리이력',
        investment: '투자',
        company_tech: '기술동향',
        company_business: '사업현황',
        company_overseas: '해외진출',
        company_support: '지원사업',
        company_patent: '특허',
        company_financial: '재무정보',
        company_workforce: '인력현황',
    };

    public items: any[] = [];
    public loaded: boolean = false;
    public total: number = 0;

    public search: any = { page: 1, text: '', category: '' };

    public pagination: any = {
        end: -1,
        start: -1,
    };

    public categories: any[] = [
        { key: '', label: '전체' },
        { key: 'notice', label: '공지사항' },
        { key: 'community', label: '커뮤니티' },
        { key: 'expert', label: '전문가풀' },
        { key: 'qna', label: '문의사항' },
        { key: 'company_activity', label: '기업활동' },
        { key: 'investment', label: '투자기록' },
        { key: 'company_data', label: '기업정보' },
    ];

    public selectedPost: any = null;
    public postComments: any[] = [];
    public postLoading: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        await this.load(1);
    }

    public async load(page: number = 1) {
        this.search.page = page;
        this.loaded = false;
        this.items = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);
        if (code != 200) return;

        let { rows, lastpage, total } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.items = rows;
        this.total = total;
        this.pagination.start = startpage;
        this.pagination.end = lastpage;
        this.loaded = true;
        await this.service.render();
    }

    public async filterCategory(key: string) {
        this.search.category = key;
        await this.load(1);
    }

    public async searchText() {
        await this.load(1);
    }

    public getCategoryClass(category: string): string {
        if (category === 'notice') return 'bg-blue-50 text-blue-700';
        if (category === 'investment') return 'bg-amber-50 text-amber-700';
        if (category && category.startsWith('company_')) return 'bg-emerald-50 text-emerald-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public async openPost(item: any) {
        this.postLoading = true;
        this.selectedPost = item;
        this.postComments = [];
        await this.service.render();

        const { code, data } = await wiz.call("detail", {
            id: item.id,
            feed_type: item.feed_type || 'board'
        });
        if (code === 200) {
            this.selectedPost = data.item;
            this.postComments = data.comments || [];
        }
        this.postLoading = false;
        await this.service.render();
    }

    public async closePost() {
        this.selectedPost = null;
        this.postComments = [];
        await this.service.render();
    }

    public goEdit(item: any) {
        if (item.feed_type === 'board') {
            this.service.href(`/admin/invest/board/${item.category}/${item.id}`);
        }
    }

    public formatter = {
        date: (val: string) => {
            if (!val) return '-';
            return String(val).substring(0, 10);
        }
    };
}

export default PortalLpsysadminBoardAllComponent;